import { CpuIcon, MessageSquareIcon, ZapIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { formatContextLength } from './model-selector-combobox.helper'

export interface ModelInfoStatsProps {
  contextLength: number
  maxCompletionTokens: number | null
  modality: string
}

export const ModelInfoStats = ({
  contextLength,
  maxCompletionTokens,
  modality,
}: ModelInfoStatsProps): ReactNode => (
  <div className="model-info-stats mb-3 flex flex-wrap gap-3">
    <div className="flex items-center gap-1.5 text-muted-foreground">
      <MessageSquareIcon className="size-3.5" />
      <span className="text-xs">Context: {formatContextLength(contextLength)}</span>
    </div>
    <div className="flex items-center gap-1.5 text-muted-foreground">
      <ZapIcon className="size-3.5" />
      <span className="text-xs">
        Max output: {maxCompletionTokens ? formatContextLength(maxCompletionTokens) : 'N/A'}
      </span>
    </div>
    <div className="flex items-center gap-1.5 text-muted-foreground">
      <CpuIcon className="size-3.5" />
      <span className="text-xs">{modality}</span>
    </div>
  </div>
)

ModelInfoStats.displayName = 'ModelInfoStats'
